import { render, staticRenderFns } from "./DoPayment.vue?vue&type=template&id=44954186&"
import script from "./DoPayment.vue?vue&type=script&lang=js&"
export * from "./DoPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports